import { FC, useState } from 'react'
import dayjs, { Dayjs } from 'dayjs'
import DesignerMonthlySummary from './components/designer-monthly-summary'

const DesignerContent: FC = () => {
    const [month, setMonth] = useState<Dayjs>(() => dayjs())

    return <DesignerMonthlySummary month={month} onMonthChange={setMonth} />
}

export default DesignerContent
